// Polyfill for process and process.env in the browser MUST come first
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.global = window.global || window;
  // @ts-ignore
  window.process = window.process || { env: {} };
  // @ts-ignore
  window.process.env = window.process.env || {};
  // Standard Vite doesn't define NODE_ENV on process.env by default
  // @ts-ignore
  window.process.env.NODE_ENV = window.process.env.NODE_ENV || import.meta.env.MODE;
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
